import { render, staticRenderFns } from "./CheckParesButtons.vue?vue&type=template&id=5295c324&"
import script from "./CheckParesButtons.vue?vue&type=script&lang=js&"
export * from "./CheckParesButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports